import theme, { fontEncodeSans } from '@theme';

export const flexBetween = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
};

export const flexBetweenCenter = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const flexBetweenEnd = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
};

export const flexStart = {
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
};

export const flexStartCenter = {
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
};

export const flexStartEnd = {
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'flex-end',
};

export const flexEnd = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'flex-start',
};

export const flexEndCenter = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
};

export const flexEndEnd = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'flex-end',
};

export const flexAround = {
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'flex-start',
};

export const flexAroundCenter = {
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'center',
};

export const flexAroundEnd = {
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'flex-end',
};

export const flexCenter = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

export const flexCenterStart = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
};

export const flexColumn = {
  display: 'flex',
  flexDirection: 'column',
};

export const flexColumnBetween = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
};

export const flexColumnBetweenCenter = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alingItems: 'center',
};

export const flexColumnCenter = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
};

export const encodeSansS18W600 = {
  fontFamily: fontEncodeSans.style.fontFamily,
  fontSize: 18,
  fontWeight: 600,
};

export const navbarButtonStyles = {
  ...flexStartCenter,
  color: 'common.greyHeaderTable',
  fontSize: 16,
  letterSpacing: '0.15px',
  textTransform: 'unset',
  borderRadius: 1,
  borderBottom: '4px solid transparent',
  px: { xs: 2, sm: 3 },
  height: '100%',
  width: '100%',
  '&.active': {
    color: { xs: theme.palette.primary.main, sm: '#535554' },
    bgcolor: { xs: 'transparent', sm: '#edf4fc' },
  },
};

export const navbarButtonStylesDesktop = {
  ...flexBetweenCenter,
  color: 'common.greyHeaderTable',
  fontSize: 16,
  height: 52,
  p: theme.spacing(0.625, 2),
  textTransform: 'unset',
  borderRadius: 0,
  borderBottom: '4px solid transparent',
  whiteSpace: 'nowrap',
  '&.active': {
    color: theme.palette.primary.main,
    borderBottom: `4px solid ${theme.palette.primary.main}`,
  },
  '&:hover': { bgcolor: 'transparent', color: theme.palette.primary.main },
};
